import React, {useState} from 'react';
import EditTask from './EditTask';


const Card = ({taskobj, index,deleteTask,updateListArray}) => {
  const [modal, setModal] = useState(false);
  const colors = [
    {
        primaryColor : "#5D93E1",
        secondaryColor : "#ECF3FC"
    },
    {
        primaryColor : "#F9D288",
        secondaryColor : "#FEFAF1"
    },
    {
        primaryColor : "#5DC250",
        secondaryColor : "#F2FAF1"
    },
    {
        primaryColor : "#F48687",
        secondaryColor : "#FDF1F1"
    },
    {
        primaryColor : "#B964F7",
        secondaryColor : "#F3F0FD"
    }
]
     const toggel = () => (setModal(!modal));

    const updateTask = (obj) =>{
       updateListArray(obj,index);
    } 
   
    const handleDelete = () =>{
         deleteTask(index)
    }
    return (
      <div class = "card-wrapper">
      <div class = "task-holder">
        <div class = "card-top" style={{"background-color": colors[index%5].primaryColor}}>
          <span class = "myheader">{taskobj.Name}</span>
          </div>
          <p className="mt-3 mydiscription" style={{"marginLeft":"10px"}}>{taskobj.Description}</p>
         <div style={{"position": "absolute", "right" : "20px", "bottom" : "20px"}}>
            <i class ="far fa-edit " style={{"color" : colors[index%5].primaryColor,"marginRight":"15px","cursor":"pointer"}} onClick={() => setModal(true)}></i>
            <i class="fas fa-trash-alt" style={{"color" : colors[index%5].primaryColor,"cursor":"pointer" }} onClick={handleDelete}></i>
          </div>
        </div> 
         <EditTask modal={modal} toggle={toggel} updateTask={updateTask} taskobj={taskobj}/>
      </div>  
    );
}

export default Card;